import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const generatePayrollRun = async (data) => {
  const res = await axiosInstance.post("/api/payroll-runs/create", data);
  return res.data;
};

export const getAllPayrollRuns = async (filters = {}) => {
  const res = await axiosInstance.get("/api/payroll-runs/all", { params: filters });
  return res.data;
};

export const getPayrollRunById = async (id) => {
  const res = await axiosInstance.get(`/api/payroll-runs/${id}`);
  return res.data;
};

export const getPayslipsByRun = async (id) => {
  const res = await axiosInstance.get(`/api/payroll-runs/${id}/payslips`);
  return res.data;
};

export const approvePayrollRun = async (id) => {
  const res = await axiosInstance.put(`/api/payroll-runs/approve/${id}`);
  return res.data;
};

export const publishPayrollRun = async (id) => {
  const res = await axiosInstance.put(`/api/payroll-runs/publish/${id}`);
  return res.data;
};

export const rejectPayrollRun = async (id, reason = "") => {
  const res = await axiosInstance.put(`/api/payroll-runs/reject/${id}`, {
    reason,
  });
  return res.data;
};

export const revertPayrollRun = async (id) => {
  const res = await axiosInstance.put(`/api/payroll-runs/revert/${id}`);
  return res.data;
};

export const lockPayrollRun = async (id) => {
  const res = await axiosInstance.put(`/api/payroll-runs/lock/${id}`);
  return res.data;
};

export const updatePayslipPayment = async (id, data) => {
  const res = await axiosInstance.put(`/api/payroll-runs/payslips/payment/${id}`, data);
  return res.data;
};

export const bulkUpdatePayslipPayment = async (runId, data) => {
  const res = await axiosInstance.put(
    `/api/payroll-runs/payslips/payment/bulk/${runId}`,
    data
  );
  return res.data;
};
